module.exports = "./img/9dc8f44cdb059979c55cc9b636f3efa9.jpg";